import React from 'react'
import EditAcademicMembersForm from '../../features/viewAcademicMember/EditAcademicMembersForm'

const EditAcademicMembers = () => {
    return (<EditAcademicMembersForm />)
}

export default EditAcademicMembers